<template>
    <th v-bind="$attrs" v-on="$listeners">
        <slot v-bind="attrs">
            <slot name="before-column" v-bind="attrs">
                <oc-plugin-slot name="before-column" v-bind="attrs" ref="beforeColumn" />
            </slot>
            <oc-plugin-slot name="column-content" v-bind="attrs" ref="columnContent">{{title}}</oc-plugin-slot>
            <slot name="after-column" v-bind="attrs">
                <oc-plugin-slot name="after-column" v-bind="attrs" ref="afterColumn" />
            </slot>
        </slot>
    </th>
</template>

<script>
export default {
    name: "oc-table-column",
    props: {
        title: {
            type: [String, Number, Boolean],
            default: null
        },
        field: {
            default: null
        }
    },
    computed: {
        attrs() {
            return Object.assign({}, this.$props, this.$attrs)
        }
    }
}
</script>
